import ReminderScheduleEntityContent from '@/components/entity-detail/components/Entity/ReminderScheduleEntity';
import type { TDetailServiceParams } from '@/components/entity-detail/types/EntityType.types';
import { taskCheckService } from '@/services/rest';
import type { TaskCheckResponse } from '@/types/apps/task-check.type';
import type { ApiResponse } from '@/types/common/api.type';
import { t } from '@/utils/lang';
import { Entity } from '../entity';

export class ReminderScheduleEntity extends Entity {
    public getTitleTemplate(response?: string): string {
        if (!response) {
            return t('Kế hoạch bảo trì');
        }

        return `${t('Kế hoạch bảo trì')}: ${this.getTitle(response)}`;
    }

    public getEntityComponent(): any {
        return ReminderScheduleEntityContent;
    }

    public getIncludeProperties() {
        return {};
    }

    public getDetailService(
        params: TDetailServiceParams
    ): Promise<ApiResponse<TaskCheckResponse>> {
        return taskCheckService().detail(params.id, {
            ...this.getIncludeProperties(),
            ...params,
        });
    }

    public getFieldName(): string {
        return 'name';
    }

    public getDetailUrl(id: string): string {
        return this.routeManager.getRouteMap()[this.getRouteDetail()].path(id);
    }

    public showDetailButton(): boolean {
        return false;
    }

    public getRouteDetail(): string {
        return this.routeManager.REMINDER_SCHEDULE;
    }
}
